// extracted by mini-css-extract-plugin
export default {"Container":"TopCategoriesCard_Container__fbjVT","Image":"TopCategoriesCard_Image__0wSN6","Title":"TopCategoriesCard_Title__IS2f9"};